import React from 'react';

const PowerBI: React.FC = () => {
  return (
    <div className="w-full h-[calc(100vh-4rem)]">
      <iframe
        title="Power BI Report"
        width="100%"
        height="100%"
        src="https://app.powerbi.com/view?r=eyJrIjoiZjRmZjBlYzgtNjNkOS00NWMyLWJiMmEtNjQ5NjQyOGE4Y2I0IiwidCI6IjQ2MzJhYTFkLWFlNGQtNGMwMS05MjA1LWM1MTkwYTU2YjAyZCJ9"
        frameBorder="0"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

export default PowerBI;
